import { Injectable } from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import swal from 'sweetalert2';

@Injectable()
export class MainAlertService {

  constructor() { }

  generateAlert(type: string, message: string, options?: any) {
    if (message !== '') {
      if (type === 'error') {
        this.alertCustomError(message);
      } else {
        this.alertCustomSuccess(message, options);
      }
    }
  }

  alertHttpErrorResponse(error: HttpErrorResponse) {
    const defaultTitle = 'เกิดข้อผิดพลาด';
    const defaultMessage = 'ขออภัย! ระบบขัดข้องกรุณาทำรายการใหม่ในภายหลัง';

    if (!swal.isVisible()) {
      if (error.status >= 500) {
        swal({
          type: 'error',
          title: defaultTitle,
          text: defaultMessage,
          heightAuto: false
        });
      } else if(error.status === 404 || error.status === 400) {
        if (error.error && Array.isArray(error.error.errors) && error.error.errors.length != 0) {
          swal({
            type: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: error.error.errors[0].message,
            heightAuto: false
          });
        } else {
          swal({
            type: 'error',
            title: defaultTitle,
            text: defaultMessage,
            heightAuto: false
          });
        }
      } else if(error.status === 400) {
        if (error.error && error.error.errors.length != 0) {
          swal({
            type: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: error.error.errors[0].message,
            heightAuto: false
          });
        } else {
          swal({
            type: 'error',
            title: defaultTitle,
            text: defaultMessage,
            heightAuto: false
          });
        }
      } else {
        if (!error.message) {
          this.generateAlert('error', error.message)
        } else {
          swal({
            type: 'error',
            title: defaultTitle,
            text: defaultMessage,
            heightAuto: false
          });
        }
      }
    }
  }

  alertCustomError(message: string) {
    swal({
      type: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: message,
      heightAuto: false
    });
  }

  alertCustomSuccess(message: any, options?: any) {
    swal({
      type: 'success',
      title: message,
      showConfirmButton: !!(options && options.showConfirmButton),
      timer: options && options.timer ? options.timer:'1500',
      heightAuto: false
    });
  }

  alertAPIError(error: HttpErrorResponse) {
    const errorMessage = this.getNested(error, 'error', 'errors', '0', 'message');
    
    if(errorMessage) {
      this.alertCustomError(errorMessage);
    } else {
      this.alertHttpErrorResponse(error);
    }
  }

  private getNested(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/services/main-alert.service.ts